import Mapbox from 'index.vue';
import { BaseFeatureLayer } from './baseFeatureLayer';
export class PoisLayer extends BaseFeatureLayer {
    constructor(mapboxInstance: InstanceType<typeof Mapbox>) {
        super(mapboxInstance, '', 'pois-layer', 'pois-source', 'symbol', {
            'icon-image': ['get', 'url'],
            'icon-size': ['/', ['get', 'size'], 1],
            'icon-allow-overlap': true,
            'icon-anchor': 'top-left',
            'icon-offset': [-26, -26],
            'symbol-sort-key': ['get', 'zIndex'],
        }, {
            'icon-opacity': 0.75, // <- Set opacity here (0 = fully transparent, 1 = fully opaque)
        },true); 
    }
    public DataChanged = () => {
        let allPois: any[] = [];
        if (this.mapboxInstance.pois !== null) {
            allPois = allPois.concat(this.mapboxInstance.pois);
        }
        const uniqueUrls = new Set<string>();
        allPois.forEach((poi: any) => {
            const url = poi.poiSetId != null ? '/api/models/' + this.mapboxInstance.model.id + '/poisets/' + poi.poiSetId + '/logo?r=' + poi.logoHash : '/api/models/' + this.mapboxInstance.model.id + '/poisets/logo';
            uniqueUrls.add(url);
        });
        const loadImagePromises = super.LoadImages(uniqueUrls);
        const features: any[] = [];
        allPois.forEach((poi: any) => {
            const url = poi.poiSetId != null ? '/api/models/' + this.mapboxInstance.model.id + '/poisets/' + poi.poiSetId + '/logo?r=' + poi.logoHash : '/api/models/' + this.mapboxInstance.model.id + '/poisets/logo';
            features.push({
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [poi.lng, poi.lat] as [number, number],
                },
                properties: { url: url, size: 0.65, zIndex: 1, title: poi.name}
            })
        });
        (async () => {
            await Promise.all(loadImagePromises);
            super.SetFeatures(features);
        })();
    };
}